import useQueryParam from './useQueryParam';

export default function useReturnUrl() {
  const returnUrlA = useQueryParam('return_url');
  const returnUrlB = useQueryParam('returnUrl');
  const returnUrlC = useQueryParam('redirect_uri');

  return returnUrlA || returnUrlB || returnUrlC;
}
